module.exports = __webpack_public_path__ + "img/街道路边.fa765c54.png";